import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { APP_CONFIG } from './app.config';


export const bootstrap = async () => {
  return bootstrapApplication(AppComponent, APP_CONFIG)
    .then(() => console.log('Bootstrapping completed.'))
    .catch((err) => {
      console.error(err);
      //window.location.assign('/error/navigation');
    });
}
